export const VENDOR_PROFILE_LISTING = [
  {
    id: "vendorName",
    label: "Vendor Name",
  },
  {
    id: "vendorCode",
    label: "Vendor Code",
  },
  {
    id: "email",
    label: "Email",
  },
  {
    id: "mobile",
    label: "Vendor SPOC Mobile Number",
  },
  {
    id: "firstName",
    label: "SPOC First Name",
  },
  {
    id: "lastName",
    label: "SPOC Last Name",
  },
];
export const VENDOR_FC_LISTING_COLUMNS = [
  {
    id: "fcCode",
    label: "FC Code",
  },
  { id: "fcName", label: "FC Name" },
  {
    id: "actions",
    label: "Actions",
  },
];
